export const AlarmOn = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m17.375 12.5.75.75 1.5-1.5M21 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M11.246 16.2c0 .994-.782 1.8-1.746 1.8s-1.745-.806-1.745-1.8m2.79-7.657c.254-.27.41-.638.41-1.043 0-.828-.652-1.5-1.455-1.5s-1.454.672-1.454 1.5c0 .405.155.773.409 1.043m4.536 2.977c0-.827-.368-1.621-1.023-2.206S10.426 8.4 9.5 8.4s-1.814.329-2.468.914c-.655.585-1.023 1.379-1.023 2.206 0 1.37-.329 2.37-.74 3.087-.468.816-.702 1.225-.693 1.322.01.112.03.147.118.213.077.058.462.058 1.233.058h7.146c.771 0 1.156 0 1.233-.058.088-.066.107-.101.118-.213.01-.097-.225-.506-.693-1.322-.41-.717-.74-1.718-.74-3.087"
    />
  </svg>
);
